module.exports = __webpack_public_path__ + "models/tutor4.9f67cca.atlas";